<template>
  <div :class="MainAuth.main">
    <div :class="$style.authbox">
      <div class="form" v-loading="loading" id="boxauth">
        <h1 :class="$style.texth1">Informe o código para continuar.</h1>
        <br>
        <p class="mb-2" style="line-height: 20px;">{{txt}}</p>
        <div :class="$style.boxTime">
          {{countDown}}
        </div>
        <div style="display: flex; justify-content: center;">
          <PincodeInput
              v-model="code"
              placeholder=""
              :length="digito"
          />
        </div>
        <el-button v-if="isBack" @click="() => {$router.push({name: 'auth.login'})}" style="width: 100%; margin-top: 30px" size="large" class="raise-primary" type="primary">Voltar</el-button>
        <el-button v-else @click="submitCod()" :disabled="isSend" style="width: 100%; margin-top: 30px" size="large" class="raise-primary" type="primary">Enviar</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import MainAuth from "../MainAuth.scss?module";
import PincodeInput from 'vue-pincode-input';
import {makeErrorFilds, setFormData} from "@/app/plugins/utils";
import {postLogin, postLogin2FA} from "@/app/domains/Auth/services";
import {mapGetters} from "vuex";
import {currentUser} from "@/app/domains/Auth/store/getters";
export default {
  name: "TwoFactor",
  components: {
    PincodeInput
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    MainAuth() {
      return MainAuth;
    }
  },
  data () {
    return {
      loading: false,
      digito: 6,
      countDown: 300,
      isBack: false,
      isSend: true,
      code: '',
      txt: 'Abra o aplicativo usado como autenticador em seu dispositovo e insira o pin informado'
    }
  },
  watch: {
    'code': function (pa) {
      if (pa.length === this.digito) {
        this.isSend = false
      } else {
        this.isSend = true
      }
    }
  },
  methods: {
    async submitCod () {
      try {
        let response = await postLogin2FA({token: this.code})
        this.$store.commit('Auth/SET_TOKEN', response.data.access_token)
        await this.$router.push({ name: "home2.index" });
      } catch (e) {
        if (e.body.data) {
          this.$message({
            showClose: true,
            message: e.body.data,
            type: 'error'
          });
        } else {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        }
      } finally {
        this.loading = false
      }
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        
        this.isBack = true
      }
    }
  },
  created () {
    this.countDownTimer()
    if (this.currentUser.type_two_factor === "google2fa") {
      this.txt = 'Abra o aplicativo usado como autenticador em seu dispositovo e insira o pin informado'
    }
    
  }
}
</script>

<style lang="scss" module>
.boxTime {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 900;
  color: #9ca3a6;
  padding: 15px;
}
.authbox {
  max-width: 450px;
  padding: 0 3.5em;
}
.texth1 {
  font-size:1.7rem;
}
@media (max-width: 800px) {
  .authbox {
    max-width: 100%;
    padding: 0 1.5em;
  }
}
</style>
